export { default as selectLoanTypeModalBg } from './select-loan-type-modal-bg.png';
export { default as fixFlipCover } from './fix-flip-cover.png';
export { default as groundUpCover } from './ground-up-cover.png';
export { default as singlePropertyCover } from './single-property-cover.png';
export { default as backArrow } from './backArrow.svg';